import { FC } from 'react'

import { T } from '@tribeplatform/react-components/i18n'
import { ActionPanel } from '@tribeplatform/react-ui-kit/ActionPanel'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { CookieKind, enableCookies } from './utils/cookie-settings'

type CookieConsentPopUpProps = {
  onManage: () => void
  onClose: () => void
}

export const CookieConsentPopUp: FC<CookieConsentPopUpProps> = ({
  onManage,
  onClose,
}) => {
  const onAcceptAll = () => {
    enableCookies([
      CookieKind.ADVERTISING_AND_TRACKING,
      CookieKind.ANALYTICS_AND_FUNCTIONAL,
    ])
    onClose()
  }
  return (
    <ActionPanel
      className="cookie-concent-popup"
      description={
        <T
          defaultMessage="This website uses cookies to help personalize and improve content and services. You can review and update your cookie settings at any time."
          id="CookieConsent.Description"
        />
      }
      placement="trailing"
    >
      <div className="flex space-s-2">
        <Button variant="outline" onClick={onManage}>
          <T
            defaultMessage="Manage preferences"
            id="CookieConsent.Actions.Manage"
          />
        </Button>
        <Button variant="primary" onClick={onAcceptAll}>
          <T
            defaultMessage="I’m fine with cookies"
            id="CookieConsent.Actions.Accept"
          />
        </Button>
      </div>
    </ActionPanel>
  )
}
